<mat-toolbar class="mat-primary">
  <span fxFlex>Neuigkeiten</span>
  <mat-icon class="cursor-mat-element" mat-dialog-close aria-label="Schließen">close</mat-icon>
</mat-toolbar>
<mat-dialog-content class="app-news-modal__content">
  <div *ngIf="news === null" class="app-news-modal__loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  <p *ngIf="news?.length === 0" class="app-news-modal__empty" id="app-news-empty">
    {{ loadFailed ? 'Die Neuigkeiten konnten nicht geladen werden.' : 'Aktuell gibt es keine Neuigkeiten.' }}
  </p>
  <article *ngIf="singleNews as item" class="app-news-modal__single" id="app-news-single">
    <h3 class="app-news-modal__single-title app-news-modal__title-text">{{ item.title }}</h3>
    <div class="app-news-modal__single-date">{{ item.publishedAt | date : 'dd.MM.yyyy' }}</div>
    <div class="app-news-modal__description" [innerHTML]="item.description | safeHtmlPipe"></div>
  </article>
  <mat-accordion *ngIf="news && news.length > 1" multi>
    <mat-expansion-panel *ngFor="let item of news" class="app-news-modal__panel">
      <mat-expansion-panel-header class="app-news-modal__header">
        <mat-panel-title class="app-news-modal__title">
          <span class="app-news-modal__title-text">{{ item.title }}</span>
          <span class="app-news-modal__date-inline">{{ item.publishedAt | date : 'dd.MM.yyyy' }}</span>
        </mat-panel-title>
        <mat-panel-description class="app-news-modal__date">
          {{ item.publishedAt | date : 'dd.MM.yyyy' }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="app-news-modal__description" [innerHTML]="item.description | safeHtmlPipe"></div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close id="app-news-close-button">Schließen</button>
</mat-dialog-actions>
